export const photos = [
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521425/KaybolanYillar/kaybolankapak.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521450/KaybolanYillar/FILE_087C87-1EDED5-EF239B-0F6968-DE276A-07CDE0.jpg',
    'https://res.cloudinary.com/dmdcrs852/image/upload/v1553521450/KaybolanYillar/FILE_D28B6A-AA2EE1-3F7C90-5A0AB4-344423-9BFCF5_1.jpg'
];